
export const FormatPhoneNumber = ( value: string ) => {

    const digits = value.replace(/\D/g, '').slice( 0, 10 );

    if ( digits.length === 0 ) return '';

    if ( digits.length <= 3 ) {
        return `(${ digits }`;
    }

    if ( digits.length <= 6 ) {
        return `(${ digits.slice(0, 3) }) ${ digits.slice(3) }`;
    }

    return `(${ digits.slice(0, 3) }) ${ digits.slice(3, 6) }-${ digits.slice(6) }`;
}

export const ClearFormatPhoneNumber = ( value: string ) => value.replace(/\D/g, "").slice( 0, 10 )